<div class="left navside dk" layout="column">


  <div flex-no-shrink="">
    <div class="nav-fold">
    </div>
  </div>

  <div flex class="hide-scroll">
    <gp-menu></gp-menu>
  </div>

</div>

